module.exports = __webpack_public_path__ + "statics/img/4-5.2299abc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/4-5.png
// module id = kutB
// module chunks = 1